import {createSelector} from 'reselect';

export const getInstitutionPermissionSelector = state =>
  state.permissions.instiutionPermissions;
export const getUserPermissionSelector = state =>
  state.permissions.userPermissions;
